import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_EGRESO_CALADO } from '../../../../config/forms'
import GrillaCallesDeCaladoEgreso from '../../components/GrillaCallesDeCaladoEgreso'
import { Button, Badge } from 'react-bootstrap'
import { ToastContainer } from 'react-toastify'
import StatusModal from '../../../Forms/SharedComponents/containers/StatusModal'
import { Dialog } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import ConfirmacionEgresoSeleccionados from './ConfirmacionEgresoSeleccionados'
import { obtenerCallesDeBruto } from '../../../Pesado/actions'
import { getCamionesCallesDeCaladoEgreso, cargarCalleDeCaladoEgreso, egreso } from '../../actions'

function EgresoCalado (props) {
  const { ceaCallesCaladoEgreso, getCamionesCallesDeCaladoEgreso, obtenerCallesDeBruto } = props
  const [open, setOpen] = useState(false)

  useEffect(() => {
    getCamionesCallesDeCaladoEgreso()
    obtenerCallesDeBruto()
  }, [getCamionesCallesDeCaladoEgreso, obtenerCallesDeBruto])

  const onSelectionChange = (selections) => {
    props.cargarCalleDeCaladoEgreso(selections)
  }

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  const handleEgreso = () => {
    props.egreso()
    handleClose()
  }

  const onSelectedCalleBruto = (calle) => {
    const { change: formChange } = props
    formChange('calleDeBruto', calle)
  }

  const hideStatus = () => {
    // props.hideCeaCaladoEgresoProcesados()
    props.getCamionesCallesDeCaladoEgreso()
  }

  const renderAcciones = () => {
    const { egresosSeleccionados, ceaCallesCaladoEgreso } = props
    const disabled = egresosSeleccionados.length === 0

    return (
      <div className='botones-acciones-egreso-calado'>
        <Button
          variant='success'
          onClick={handleOpen}
          disabled={disabled}
          size='lg'
        >
          Egreso
        </Button>
        <div>
          <h2>
            <Badge variant='light'>Total: {(ceaCallesCaladoEgreso.length) ? ceaCallesCaladoEgreso.length : 0}</Badge>
            <Badge variant='light'>Seleccionados: {(egresosSeleccionados.length) ? egresosSeleccionados.length : 0}</Badge>
          </h2>
        </div>
      </div>
    )
  }

  const show = (props.ceaCaladoEgresoProcesados > 0 || props.errorCeaCaladoEgresoProcesados)

  const rol = props.roles.filter(roles => roles === 'SUPERVISOR' || roles === 'SUPMANTENIMIENTO' || roles === 'DESARROLLADOR')
  const rolAutorizado = (rol[0] === 'SUPERVISOR' || rol[0] === 'SUPMANTENIMIENTO' || rol[0] === 'DESARROLLADOR')

  return (
    <div className='calado-egreso'>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogView
          cancelCallback={handleClose}
          title=' '
          content={<ConfirmacionEgresoSeleccionados
            onSelectedCalleBruto={onSelectedCalleBruto}
            handleSubmit={handleEgreso}
          />
          }
        />
      </Dialog>
      <StatusModal
        show={show}
        onClick={hideStatus}
        message={`Cargas egresadas ${props.ceaCaladoEgresoProcesados}`}
        errorMessage={props.errorCeaCaladoEgresoProcesados}
      />
      <ToastContainer />
      <h2>Cargas en calles de calado</h2>
      { props.requestingCamionesCallesCalado
        ? <span>Consultando...</span>
        : <>
          { rolAutorizado && <div> { renderAcciones() } </div> }
          <br />
          <GrillaCallesDeCaladoEgreso
            rows={ceaCallesCaladoEgreso}
            egresosSeleccionados={props.egresosSeleccionados}
            onSelectionChange={onSelectionChange}
          />
        </>
      }
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    requestingCamionesCallesCalado: state.calado.requestingCamionesCallesCalado,
    ceaCallesCaladoEgreso: state.calado.ceaCallesCaladoEgreso,
    egresosSeleccionados: state.calado.egresosSeleccionados,
    ceaCaladoEgresoProcesados: state.calado.ceaCaladoEgresoProcesados,
    errorceaCaladoEgresoProcesados: state.calado.errorceaCaladoEgresoProcesados,
    roles: state.auth.roles
  }
}

const mapActionsToProps = {
  getCamionesCallesDeCaladoEgreso,
  obtenerCallesDeBruto,
  cargarCalleDeCaladoEgreso,
  egreso
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(
  reduxForm({
    form: FORM_EGRESO_CALADO
  })(EgresoCalado)
)
